import { signOut } from 'firebase/auth';
import React, {useState, useEffect} from 'react';
import {useAuthState} from 'react-firebase-hooks/auth';
import { Link, useNavigate } from 'react-router-dom';
import auth from '../../firebase.init'
const MyAppointment = () => {
    const [appointments, setAppointments] = useState([]);
    const [user] = useAuthState(auth);
    const navigate = useNavigate();
  
    useEffect(() => {
      if (user) {
            fetch(`https://frozen-ridge-08310.herokuapp.com/booking?patient=${user.email}`, {
              method: 'GET',
              headers: {
                  'authorization': `Bearer ${localStorage.getItem('accessToken')}`
              }
          })
              .then(res => {
                  console.log('res', res);
                  if (res.status === 401 || res.status === 403) {
                      signOut(auth);
                      localStorage.removeItem('accessToken');
                      navigate('/');
                  }
                  return res.json()
              })
              .then(data => {

                  setAppointments(data);
              });
      }
  }, [user])
    return (
        <div>
            <h2>my appointments: {appointments.length}</h2>
            <div class="overflow-x-auto">
  <table class="table w-full">

    <thead>
      <tr>
        <th></th>
        <th>Name</th>
        <th>Date</th>
        <th>Slot</th>
        <th>Treatment</th>
        <th>Payment</th>
      </tr>
    </thead>
    <tbody>
       {
           appointments.map((a, index)=> <tr key={a._id}>
               <th>{index + 1}</th>
               <td>{a.patientName}</td>
               <td>{a.date}</td>
               <td>{a.slot}</td>
               <td>{a.treatment}</td>
               <td>
                 {/* {(a.price) && <button className='btn btn-xs btn-success'>Pay</button>} */}
                 {(a.price && !a.paid) && <Link to={`/dashboard/payment/${a._id}`}><button className='btn btn-xs btn-success'>pay</button></Link>}
                 {/* {(a.price && a.paid) && <span className='text-success'>paid</span>} */}
                 {(a.price && a.paid) && <div>
                  <span className='text-success'>paid</span>
                  <p>Transaction id: <span className='text-success'>{a.transactionId}</span></p>
                   </div>}
              </td>
           </tr>
           )
       }
     
    </tbody>
  </table>
</div>
        </div>
    );
};

export default MyAppointment;